import { AllowedResolution } from "../../types/resize";
import { getImageUrl } from "./utils/url";

export const NEW_SLUG = "new";

export const ART_URL = (artId: string, admin?: boolean) =>
  (admin ? "/admin" : "") + "/art/" + (artId ? artId : "");

export const ART_LIST_URL = (type?: "in-progress" | "basic", admin?: boolean) =>
  (admin ? "/admin" : "") +
  (type === "in-progress" ? "/art-in-progress" : "/art");

export const ORDER_URL = (orderId: string, admin?: boolean) =>
  (admin ? "/admin" : "") + "/order/" + (orderId ? orderId : "");
export const ORDER_LIST_URL = (
  _type?: "placed" | "in-progress" | "completed",
  admin?: boolean
) => (admin ? "/admin" : "") + "/order/";
export const SHIPMENT_URL = (
  shipmentId: string,
  admin?: boolean,
  orderId?: string
) =>
  (admin ? "/admin" : "") +
  "/shipment/" +
  shipmentId +
  (orderId ? "?orderSlug=" + orderId : "");

export const CART_URL = () => "/cart";
export const CHECKOUT_URL = (checkoutId?: string) =>
  "/cart/checkout" + (checkoutId ? "/" + checkoutId : "");
export const CHECKOUT_SUCCESS_URL = (checkoutId: string) =>
  `/cart/checkout/${checkoutId}/success`
// export const DELIVERY_ADDRESS = (cartId: string) =>
//   "/cart/" + cartId + "/delivery";

export const IMAGE_URL = (
  imagePath: string,
  options?: { useImageSize?: AllowedResolution }
) => {
  return getImageUrl(
    import.meta.env.VITE_SITE_URL,
    imagePath,
    options?.useImageSize
  );
};

export type AuthParams = {
  flow?: "checkout" | "resume";
  to?: string;
};

export type UserAuthPaths =
  | "create"
  | "login"
  | "challenge-login"
  | "challenge-password-reset";

export const USER_AUTH_URL = (type: UserAuthPaths, props?: AuthParams) => {
  const queryParams = [
    props?.flow
      ? PARAM_KEYS.AUTH_REDIRECT_FLOW.QUEARY_PARAM + "=" + props.flow
      : "",
    props?.to ? PARAM_KEYS.AUTH_REDIRECT_TO.QUEARY_PARAM + "=" + props.to : "",
  ].filter((key) => !!key);
  return (
    "/user/" + type + (queryParams.length ? "?" + queryParams.join("&") : "")
  );
};

export const PARAM_KEYS = {
  AUTH_REDIRECT_FLOW: {
    QUEARY_PARAM: "flow",
  },
  AUTH_REDIRECT_TO: {
    QUEARY_PARAM: "to",
  },
} as const;

export const URLS = {
  art: ART_URL,
  artList: ART_LIST_URL,
  order: ORDER_URL,
  shipment: SHIPMENT_URL,
  cart: CART_URL,
  checkout: CHECKOUT_URL,
  image: IMAGE_URL,
  user: USER_AUTH_URL,
};
